<section class="login">
    <div class="logo">
        <img src="./assets/logo.png" alt="logo">
    </div>
    <div>
        <mat-card>
            <mat-card-content>
                <form [formGroup]="loginForm" (ngSubmit)="loginSubmit()">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input type="email" matInput formControlName="username">
                        <i class="material-icons" matSuffix> email </i>
                        <mat-error *ngIf="loginFormValidate?.username?.errors?.required">
                            This field is required.
                        </mat-error>
                        <mat-error *ngIf="loginFormValidate?.username?.errors?.email">
                            Please enter valid email.
                        </mat-error>
                    </mat-form-field>
                    <br>
                    <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input matInput placeholder="Password" [type]="hide ? 'text' : 'password'" formControlName="password">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error *ngIf="loginFormValidate?.password?.errors?.required">This field is required.</mat-error>
                    </mat-form-field>
                    <br>
                    <mat-error fxLayout="row" fxLayoutAlign="center" *ngIf="is_error_msg">Invalid Credentials.</mat-error>
                    <div fxLayout="row" fxLayoutAlign="center">
                        <button type="submit" class="btn-int-blue" mat-raised-button color="primary">SIGN IN </button><br>
                    </div>

                </form>
            </mat-card-content>
            <mat-card-actions fxLayout="row" fxLayoutAlign="center">
                <button type="button" [routerLink]="['/forgot-password']" mat-button color="primary" matPrefix>Create account</button>
                <button type="button" [routerLink]="['/create-account']" mat-button color="primary" matSufix>Forgot password?</button>
            </mat-card-actions>
        </mat-card>
    </div>
    <div class="app-download-link">
        <a [href]="windowsAppLink" download class="link">Click here</a> to download desk app for windows
    </div>
</section>